import { Link } from "react-router-dom";
import { ArrowRight, Swords, Trophy, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SocialRankSection() {
  return (
    <section id="competencia" className="border-y border-border bg-primary/5 py-20 lg:py-28">
      <div className="container mx-auto grid gap-12 px-4 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div className="max-w-xl">
          <p className="text-sm font-bold uppercase text-primary">Competencia</p>
          <h2 className="mt-3 text-3xl font-bold sm:text-4xl lg:text-5xl">
            Convierte tu constancia en una referencia
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
            Cada sesión suma a tu progreso. Compara tu actividad por XP o tu desempeño en simuladores y descubre dónde estás avanzando.
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            <div className="border-l-2 border-primary pl-4">
              <Trophy className="h-5 w-5 text-primary" />
              <p className="mt-3 font-bold">Ranking por XP</p>
              <p className="mt-1 text-sm text-muted-foreground">Reconoce constancia y actividad de estudio.</p>
            </div>
            <div className="border-l-2 border-foreground pl-4">
              <Swords className="h-5 w-5" />
              <p className="mt-3 font-bold">Ranking de simuladores</p>
              <p className="mt-1 text-sm text-muted-foreground">Compara resultados obtenidos en práctica.</p>
            </div>
          </div>
          <p className="mt-7 text-sm text-muted-foreground">
            Filtra por universidad, estado, especialidad o institución para darle contexto a tu avance.
          </p>
          <Link to="/auth" className="mt-7 inline-block">
            <Button size="lg">
              Crear cuenta y competir
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="overflow-hidden border border-border bg-background shadow-[0_22px_60px_-42px_rgba(15,23,42,0.45)]">
          <div className="flex flex-col gap-4 border-b border-border p-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs font-semibold uppercase text-muted-foreground">Tablero de competencia</p>
              <p className="mt-1 text-xl font-bold">Ranking global</p>
            </div>
            <div className="flex rounded-md bg-muted p-1 text-sm">
              <span className="rounded-sm bg-background px-3 py-1.5 font-semibold shadow-sm">XP</span>
              <span className="px-3 py-1.5 text-muted-foreground">Simuladores</span>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 border-b border-border p-4 text-xs text-muted-foreground">
            {['Universidad', 'Estado', 'Especialidad', 'Institución'].map((filter) => (
              <span key={filter} className="rounded-md border border-border px-2.5 py-1.5">{filter}</span>
            ))}
          </div>
          <div className="divide-y divide-border">
            {[
              { place: '01', name: 'María G.', initials: 'MG', xp: '12,480', acc: '88%', medal: '🥇', isYou: false },
              { place: '02', name: 'Carlos L.', initials: 'CL', xp: '11,205', acc: '85%', medal: '🥈', isYou: false },
              { place: '—', name: 'Tu posición', initials: 'Tú', xp: '8,940', acc: '78%', medal: null, isYou: true },
              { place: '03', name: 'Ana M.', initials: 'AM', xp: '7,610', acc: '74%', medal: '🥉', isYou: false },
            ].map((row) => (
              <div
                key={row.name}
                className={`flex items-center gap-3 px-5 py-3.5 ${
                  row.isYou ? 'border-y-2 border-primary/40 bg-primary/5' : ''
                }`}
              >
                <span className={`w-7 shrink-0 text-center font-mono text-xs font-bold ${row.isYou ? 'text-primary' : 'text-muted-foreground'}`}>
                  {row.place}
                </span>
                <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                  row.isYou ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'
                }`}>
                  {row.initials}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className={`truncate text-sm ${row.isYou ? 'font-bold text-primary' : 'font-semibold text-foreground'}`}>
                      {row.name}
                    </span>
                    {row.medal && <span className="text-base leading-none">{row.medal}</span>}
                    {row.isYou && (
                      <span className="rounded-full bg-primary/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-primary">Tú</span>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">{row.acc} precisión</p>
                </div>
                <div className="text-right">
                  <div className="flex items-center justify-end gap-1">
                    <Zap className="h-3.5 w-3.5 text-amber-500" />
                    <span className="text-sm font-black text-foreground">{row.xp}</span>
                  </div>
                  <p className="text-[10px] uppercase tracking-wide text-muted-foreground">XP</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
